import { profileImageUrl, businessProfileImageUrl } from './mediaUrl';

/**
 * Get profile image from user object or sessionStorage
 * @param {Object} user - User object
 * @returns {string|null} - Profile image URL or null
 */
export const getProfileImage = (user) => {
  if (user?.profileImage) {
    return profileImageUrl(user.profileImage) || null;
  }

  const sessionProfileImage = sessionStorage.getItem('profileImage');
  if (sessionProfileImage) {
    return profileImageUrl(sessionProfileImage) || null;
  }

  return null;
};

/**
 * Get business profile image with comprehensive fallback handling
 * @param {Object} user - User object (can be null for guests)
 * @param {Object} businessData - Business data object
 * @returns {string|null} - Business profile image URL or null
 */
export const getBusinessProfileImage = (user, businessData = null) => {
  if (user?.profileImage) {
    const url = profileImageUrl(user.profileImage);
    if (url) return url;
  }

  const sessionProfileImage = sessionStorage.getItem('profileImage');
  if (sessionProfileImage) {
    const url = profileImageUrl(sessionProfileImage);
    if (url) return url;
  }

  if (
    businessData?.profileImage &&
    businessData.profileImage !== 'null' &&
    businessData.profileImage !== '' &&
    businessData.profileImage !== undefined
  ) {
    return businessProfileImageUrl(businessData.profileImage);
  }

  if (businessData?.companyName && !businessData?.profileImage) {
    return '/business.png';
  }

  return null;
};

/**
 * Check if user has profile image
 * @param {Object} user - User object
 * @returns {boolean} - True if user has profile image
 */
export const hasProfileImage = (user) => {
  return getProfileImage(user) !== null;
};

/**
 * Check if business has profile image
 * @param {Object} user - User object (can be null for guests)
 * @param {Object} businessData - Business data object
 * @returns {boolean} - True if business has profile image
 */
export const hasBusinessProfileImage = (user, businessData = null) => {
  return getBusinessProfileImage(user, businessData) !== null;
}; 